<div style="z-index: -1; height: 100%">
  <cst-card
    [isLoading]="!facilityNoInternal || isLoading"
    [compact]="true"
    headerIcon="note"
    >
    <ng-template cstCardTitle>
      <span i18n="@@Infoportal_ElevatorDetail_NotesFacilityOverview_Title"
        >Notes for the facility
      </span>
      <span>
        @if (!isConnected) {
          <mat-icon
            matTooltip="Keine Internetverbindung"
            style="margin-left: 50px; color: red"
            aria-hidden="false"
            aria-label="Example home icon"
            >cloud_off</mat-icon
            >
          }
        </span>
      </ng-template>
      <ng-template cstCardContent>
        <div style="display: flex; flex-direction: column; height: 100%">
          @if (displayFilter) {
            <div>
              <mat-chip-set>
                @for (filter of filtersCombined; track filter) {
                  <mat-chip
                    [removable]="filter.onRemove"
                    (removed)="filter.onRemove()"
                    [attr.title]="filter.tooltip ? filter.tooltip : null"
                    >
                    {{ filter.label }}
                    @if (filter.onRemove) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip>
                }
              </mat-chip-set>
            </div>
          }
          <div style="overflow-y: hidden">
            <app-list-view
              [dataSource]="dataSource"
              [columns]="columns"
              [compact]="true"
              [actions]="rowActions"
              id="FacilityNotes"
              [elevated]="false"
              >
              <ng-template cstListViewBottomTemplateDirective>
                @if (showPagination) {
                  <ng-container
                    *ngTemplateOutlet="cardActionsTemplate"
                  ></ng-container>
                }
                <!-- <ng-container *ngIf="showPagination">
              </ng-container>        -->
            </ng-template>
          </app-list-view>
        </div>
      </div>
    </ng-template>
    @if (!showPagination) {
      <ng-template cstCardActions>
        <ng-container *ngTemplateOutlet="cardActionsTemplate"></ng-container>
      </ng-template>
    }
  </cst-card>
</div>

<ng-template #colInfos let-value="value" let-element="element">
  @if (element.displayLevelMobile === NOTE_DISPLAY_LEVEL_MOBILE.Display) {
    <mat-icon
      class="list-icon"
      i18n-title="
        @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_DisplayOnMobile"
      title="Show note on the mobile app"
      >smartphone</mat-icon
      >
      @if (element.acknowledgedOnMobile === NOTE_ACK.Acknowledged) {
        <mat-icon
          class="list-icon"
      i18n-title="
        @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_AcknowledgedOnMobile"
          title="This note was acknowledged on the mobile app"
          >visibility</mat-icon
          >
        }
        @if (element.acknowledgedOnMobile !== NOTE_ACK.Acknowledged) {
          <mat-icon
            class="list-icon transparent"
      i18n-title="
        @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_NotAcknowledgedOnMobile"
            title="This note was not yet acknowledged on the mobile app"
            >visibility_off</mat-icon
            >
          }
        }
        @if (element.displayLevelMobile !== NOTE_DISPLAY_LEVEL_MOBILE.Display) {
          <mat-icon
            class="list-icon transparent"
    i18n-title="
      @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_DontDisplayOnMobile"
            title="Don't show this note on the mobile app"
            >phonelink_erase
          </mat-icon>
        }

        @if (element.displayLevel === NOTE_DISPLAY_LEVEL.AktivAnzeigen) {
          <mat-icon
            class="list-icon"
            title="Displayed as a pop-up in Belsoft"
    i18n-title="
      @@Infoportal_ElevatorDetail_NotesFacilityOverview_Cell_DisplayLevel"
            >info
          </mat-icon>
        }
      </ng-template>

      <ng-template #cardActionsTemplate>
        @if (isNoteFacilityCreateVisible) {
          <ctrl-btn
            [flat]="true"
            type="primary"
            i18n-content="@@InfoPortal_ElevatorsDetail_BuNoteFacilityCreate_Content"
            content="New Facility Note"
            i18n-title="@@InfoPortal_ElevatorsDetail_BuNoteFacilityCreate_Tooltip"
            title="Create a new facility note"
            icon="note"
            (click)="OnNoteFacilityCreate()"
            [disabled]="!facilityNoInternal || !isConnected"
          ></ctrl-btn>
        }
        <ctrl-btn
          [flat]="true"
          icon="filter_list"
          i18n-content="@@InfoPortal_ElevatorsDetail_WartungsHistory_BuFilter_Content"
          content="Filter"
          i18n-title="@@InfoPortal_ElevatorsDetail_WartungsHistory_BuFilter_Tooltip"
          title="Open the filter dialog"
          (click)="onExtendedFiltersClick()"
          [disable]="!isConnected"
        ></ctrl-btn>
        <ctrl-btn
          [flat]="true"
          type="default"
          icon="refresh"
          i18n-content="@@InfoPortal_ElevatorsDetail_BuNotesRefresh_Content"
          content="Refresh"
          i18n-title="@@InfoPortal_ElevatorsDetail_BuNotesRefresh_Tooltip"
          title="Refresh the list of notes"
          (click)="OnNotesRefresh()"
          [disabled]="!facilityNoInternal || isLoading || !isConnected"
        ></ctrl-btn>
      </ng-template>
